export default __webpack_public_path__ + "images/NG.b48ff88.png";